var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverlayContentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.237 9.981a1.75 1.75 0 0 1 0 2.475l-7.762 7.762 7.762 7.763a1.75 1.75 0 1 1-2.474 2.475l-9-9a1.75 1.75 0 0 1 0-2.475l9-9a1.75 1.75 0 0 1 2.474 0zM27.763 30.456a1.75 1.75 0 0 1 0-2.475l7.762-7.763-7.762-7.762a1.75 1.75 0 1 1 2.474-2.475l9 9a1.75 1.75 0 0 1 0 2.475l-9 9a1.75 1.75 0 0 1-2.474 0zM23.453 7.528a1.75 1.75 0 0 1 1.237 2.143l-5.97 22.285a1.75 1.75 0 0 1-3.382-.905L21.31 8.765a1.75 1.75 0 0 1 2.143-1.238z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayContentIcon);
export default __webpack_public_path__ + "static/media/overlay-content-icon.3c6611c92adcf2699fb07f1a81990170.svg";
export { ForwardRef as ReactComponent };